module.exports = __webpack_public_path__ + "static/media/1.1 Wartung Servatius Objekt klein.b7fbb504.jpg";